module.exports = import("https://cdnjs.cloudflare.com/ajax/libs/countup.js/2.0.7/countUp.js");;